function syncSpecialItemDelete(row) {
  if (!row) return;
  const quantity = row.querySelector('.sender-special-item-quantity');
  const action = row.querySelector('.sender-special-item-delete');
  if (!quantity || !action) return;

  const enabled = Number(quantity.value) > 0;
  if (action.tagName === 'BUTTON') {
    action.disabled = !enabled;
  } else {
    action.setAttribute('aria-disabled', String(!enabled));
    action.tabIndex = enabled ? 0 : -1;
  }
}

document.addEventListener('input', function(event) {
  if (!event.target.matches('#deal-form.sender-deal-edit-form .sender-special-item-quantity')) return;
  syncSpecialItemDelete(event.target.closest('.sender-special-item-row'));
});
document.addEventListener('change', function(event) {
  if (!event.target.matches('#deal-form.sender-deal-edit-form .sender-special-item-quantity')) return;
  syncSpecialItemDelete(event.target.closest('.sender-special-item-row'));
});

// The shared steppers update .val() without emitting input/change.
document.addEventListener('click', function(event) {
  const stepper = event.target.closest('#deal-form.sender-deal-edit-form .sender-special-item-row .plus, #deal-form.sender-deal-edit-form .sender-special-item-row .minus');
  if (!stepper) return;
  const row = stepper.closest('.sender-special-item-row');
  setTimeout(() => syncSpecialItemDelete(row), 0);
});

document.addEventListener('click', function(event) {
  const action = event.target.closest('.sender-special-item-delete');
  if (!action || !action.closest('#deal-form.sender-deal-edit-form')) return;
  if (action.disabled || action.getAttribute('aria-disabled') === 'true') {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }
  // Saved rows keep their existing Rails remote-delete link and confirmation.
  if (action.tagName === 'A') return;

  event.preventDefault();
  event.stopImmediatePropagation();
  const row = action.closest('.sender-special-item-row');
  row.querySelectorAll('input:not([type="hidden"]), textarea').forEach(field => {
    field.value = '';
  });
  const upload = row.querySelector('.edit-item-camera-upload');
  if (upload) upload.classList.remove('has-photo');
  const preview = row.querySelector('.image-preview');
  if (preview && row.dataset.placeholderImage) preview.src = row.dataset.placeholderImage;
  row.querySelector('.sender-special-item-quantity').dispatchEvent(new Event('input', { bubbles: true }));
}, true);
